export default function restoreState(key) {
  if ('sessionStorage' in window) {
    const persistedState = JSON.parse(sessionStorage.getItem(key) || '{}');
    return persistedState;
  }
}
